<!-- <div class="card-button" [hidden]="actionButtons.length == 0" *ngFor="let item of actionButtons">
    {{ item.textBeforeBtn }}
    <button class="btn f-11 position-relative top--3px" [hidden]="item.buttonText==''"
        (click)="onUserAction(item.userAction);" [class]="item.buttonClass" [ngClass]="{'disabled-state': item.disableProperty }" >
        {{ item.buttonText }}
    </button>
</div> -->

<!-- `item.buttonText` is part of the condition for the same reason `iconButtonsRenderer` requires a
     `buttonIcon`: a column whose `cellRendererSelector` can hand this same param array to the icon
     renderer carries icon-only entries meant for that one, and a label button with no label renders
     as a blank button (its `buttonConfig` entry is spread from an undefined slot). -->
@for(item of actionButtons; track item; let i = $index){<div>
    {{ item.textBeforeBtn }}
    @if(!item.hideProperty && item.buttonText){<ds-button [buttonInput]="buttonConfig[i]"
        (onClick)="onUserAction(item.userAction)"></ds-button>}
</div>}